import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import { IDateRange } from '../interfaces';

dayjs.locale('sv');

const getOrdinal = (n: number, sweedish = true) => {
  let suffixes;
  if (sweedish) {
    suffixes = [':a', ':e', ':e', ':e'];
  } else {
    suffixes = ['th', 'st', 'nd', 'rd'];
  }
  const v = n % 100;
  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

export const formatDate = (date: string, sweedish = true) => {
  const dateObj = dayjs(date);
  const day = getOrdinal(dateObj.date(), sweedish);
  const formattedDate = `${day} ${dateObj.format('MMMM YYYY')}`;
  return formattedDate;
};

export function getMonthRange(date?: string): IDateRange {
  const requestedDate = date ? new Date(date) : new Date();
  const firstDay = new Date(
    requestedDate.getFullYear(),
    requestedDate.getMonth(),
    1
  );
  const lastDay = new Date(
    requestedDate.getFullYear(),
    requestedDate.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  );

  const isoFirstDay = firstDay.toISOString();
  const isoLastDay = lastDay.toISOString();

  return {
    startDate: isoFirstDay,
    endDate: isoLastDay,
  };
}

export const getDatesBetweenTwoDates = (start: string, end: string) => {
  const arr: string[] = [];
  for (
    const dt = new Date(start);
    dt <= new Date(end);
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(dayjs(dt).format('YYYY-MM-DD'));
  }
  return arr;
};

export const getMonthNamesBetweenDates = (
  startDate: string,
  endDate: string
): string[] => {
  const lastDate = new Date(endDate);

  const months: string[] = [];
  const currentDate = new Date(startDate);

  while (currentDate <= lastDate) {
    const monthName = new Intl.DateTimeFormat('sv-SE', {
      month: 'long',
    }).format(currentDate);
    months.push(monthName.charAt(0).toUpperCase() + monthName.slice(1));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return months;
};
